<template>
  <div class="admin-fields">
    <quick-add-field v-if="editMode"></quick-add-field>
    <pulse-loader :loading="fieldsLoading" :color="primaryColour"></pulse-loader>
    <router-link v-if="editMode" :to="{ name: 'admin-new-field', params: { pageId: activePage.id } }" class="admin-fields__add-field button">Add Field</router-link>
    <vue-form-generator :schema="formSchema" :model="formModel" v-if="fields.length > 0"></vue-form-generator>
    <p v-else><em>No fields added yet</em></p>
    <router-link v-if="editMode" :to="{ name: 'admin-new-field', params: { pageId: activePage.id } }" class="admin-fields__add-field button">Add Field</router-link>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import PulseLoader from 'vue-spinner/src/PulseLoader';
  import formBuilder from '@/mixins/form-builder';
  import QuickAddField from '@/components/admin/pages/QuickAddField';

  export default {
    name: 'admin-show-page',

    props: ['editMode'],

    components: {
      'quick-add-field': QuickAddField,
      'pulse-loader': PulseLoader,
    },

    mixins: [formBuilder],

    computed: {
      ...mapState([
        'primaryColour',
      ]),

      ...mapState('admin', {
        fields: state => state.field.fields,
        fieldsLoading: state => state.field.fieldsLoading,
        pages: state => state.page.pages,
      }),

      ...mapGetters('admin', [
        'activePage',
        'activeSurvey',
        'activeFields',
      ]),

      formBuilderOptions() {
        return {
          editMode: this.editMode,
          surveyArchived: this.activeSurvey.archived,
        };
      },
    },

    watch: {
      activePage() {
        if (this.activePage.id) {
          this.fetchFields(this.activePage.id);
        }
      },

      pages() {
        if (!this.activePage.id) {
          this.setActivePage(this.pages[0].id);
        }
      },
    },

    methods: {
      ...mapMutations('admin', [
        'setActivePage',
      ]),

      ...mapActions('admin', [
        'fetchFields',
      ]),
    },

    created() {
      if (this.activePage.id) {
        this.fetchFields(this.activePage.id);
      }
    },
  };
</script>
